import { useGetIdentity } from 'react-admin';
import { authProvider } from '../../auth/authProvider';
import { LandingButton } from '../../components/pay-wall/LandingButton';

export const GetStartedButton = ({ }: {}) => {

  const { identity, isLoading: identityLoading } = useGetIdentity();

  const onGetStarted = async () => {
    if (identity?.id) {
      // User is logged in, redirect to ...
    } else {
      // User is not logged in, redirect to login
      await authProvider.login({});
    }
  };

  return (
    <LandingButton onClick={onGetStarted}>Get Started</LandingButton>
  )
};
